module.exports = __webpack_public_path__ + "static/media/bgOcean.aecd9742.jpg";